import React from "react";
import AllOrders from "./_components/AllOrders";

type Props = {
  setHeaderActions?: (node: React.ReactNode) => void;
  setHeaderButtons?: (node: React.ReactNode) => void;
};

export default function CreatedOrders({
  setHeaderActions,
  setHeaderButtons,
}: Props) {
  return (
    // <section className="min-h-[400px] mb-6 w-full max-w-full overflow-visible">
      <AllOrders
        setHeaderActions={setHeaderActions}
        setHeaderButtons={setHeaderButtons}
      />
    // </section>
  );
}
